import { appData } from '@/mocks/homeData';

export default function SectionApp() {
  const { title, subtitle, description, platforms } = appData;

  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">{title}</h2>
        <p className="text-foreground-500 text-sm md:text-base mb-4">{subtitle}</p>
        <p className="text-foreground-600 text-sm leading-relaxed max-w-2xl mx-auto mb-8">{description}</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {platforms.map((p) => (
            <div
              key={p.name}
              className="flex items-center gap-3 px-8 py-4 rounded-2xl bg-background-100 border border-background-200/60 cursor-pointer hover:bg-primary-50 transition-colors duration-200"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className={`${p.icon} text-lg`}></i>
              </div>
              <div className="text-left">
                <div className="text-foreground-800 font-bold text-sm whitespace-nowrap">{p.name}</div>
                <div className="text-foreground-400 text-xs">点击下载</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 text-foreground-400 text-xs">
          <i className="ri-smartphone-line"></i>
          <span>扫码下载 · 掌上吃瓜</span>
        </div>
      </div>
    </section>
  );
}